// -- Split menu -- //
// const splitMenu = () => {
//   const menuWrapper = document.querySelector("#navigation .navigation-in");
//   if (menuWrapper) {
//     setTimeout(() => {
//       let menuItems = menuWrapper.querySelectorAll(
//         ".menu-level-1>li:not(.appended-category):not(#nav-manufacturers)"
//       );
//       let menuHelper = document.querySelector(".menu-helper");
//       menuItems.forEach((item) => {
//         let offsetRight = item.offsetLeft + item.offsetWidth;
//         if (offsetRight > menuWrapper.clientWidth) {
//           let splitted;
//           if (!item.id == "nav-manufacturers") {
//             splitted = menuHelper.querySelector("." + item.classList[0]);
//           } else {
//             splitted = menuHelper.querySelector("#nav-manufacturers");
//           }
//           if (splitted) {
//             splitted.classList.remove("splitted");
//           }
//           item.classList.add("splitted");
//         } else {
//           let splitted = menuHelper.querySelector("." + item.classList[0]);
//           if (splitted) {
//             splitted.classList.add("splitted");
//           }
//           item.classList.remove("splitted");
//         }
//       });
//       if (
//         menuHelper.querySelector(
//           ".menu-level-1 > li:not(.splitted):not(.appended-category):not(#nav-manufacturers)"
//         )
//       ) {
//         menuHelper.classList.remove("empty");
//         menuWrapper.classList.remove("fitted");
//       } else {
//         menuHelper.classList.add("empty");
//         menuWrapper.classList.add("fitted");
//       }
//     }, 200);
//   }
// };
// const splitMenu = () => {
//   const menuWrapper = document.querySelector("#navigation .navigation-in");
//   if (menuWrapper) {
//     setTimeout(() => {
//       let menuItems = menuWrapper.querySelectorAll(
//         ".menu-level-1>li:not(.appended-category)"
//       );
//       let menuHelper = document.querySelector(".menu-helper");
//       let menuWrapperStyle = window.getComputedStyle(menuWrapper);
//       menuItems.forEach((item) => {
//         let offsetRight = item.offsetLeft + item.offsetWidth;
//         const itemInHelper =
//           item.id === "nav-manufacturers"
//             ? menuHelper.querySelector("#nav-manufacturers")
//             : menuHelper.querySelector("." + item.classList[0]);
//         if (
//           offsetRight >
//           menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)
//         ) {
//           if (itemInHelper) {
//             itemInHelper.classList.remove("splitted");
//           }
//           item.classList.add("splitted");
//         } else {
//           if (itemInHelper) {
//             itemInHelper.classList.add("splitted");
//           }
//           item.classList.remove("splitted");
//         }
//       });
//       if (
//         menuHelper.querySelector(
//           ".menu-level-1 > li:not(.splitted):not(.appended-category)"
//         )
//       ) {
//         menuHelper.classList.remove("empty");
//         menuWrapper.classList.remove("fitted");
//       } else {
//         menuHelper.classList.add("empty");
//         menuWrapper.classList.add("fitted");
//       }
//     }, 200);
//   }
// };
const splitMenu = () => {
  const menuWrapper = document.querySelector("#navigation .navigation-in");
  if (!menuWrapper) return;

  // Очищаем предыдущий таймаут, если нужно (debounce)
  if (window.splitMenuTimeout) clearTimeout(window.splitMenuTimeout);

  window.splitMenuTimeout = setTimeout(() => {
    let menuItems = menuWrapper.querySelectorAll(
      ".menu-level-1>li:not(.appended-category)"
    );
    let menuHelper = document.querySelector(".menu-helper");
    let menuWrapperStyle = window.getComputedStyle(menuWrapper);

    // --- ШАГ 1: СБРОС СОСТОЯНИЯ ---
    // Убираем класс splitted со всех элементов перед расчетом,
    // чтобы браузер мог вычислить их реальную ширину в ряд.
    menuItems.forEach((item) => item.classList.remove("splitted"));

    // --- ШАГ 2: РАСЧЕТ ---
    menuItems.forEach((item) => {
      let offsetRight = item.offsetLeft + item.offsetWidth;
      const itemInHelper =
        item.id === "nav-manufacturers"
          ? menuHelper.querySelector("#nav-manufacturers")
          : menuHelper.querySelector("." + item.classList[0]);

      const availableWidth =
        menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight);

      if (offsetRight > availableWidth) {
        item.classList.add("splitted");
        if (itemInHelper) {
          itemInHelper.classList.remove("splitted");
        }
      } else {
        // Элемент помещается
        if (itemInHelper) {
          itemInHelper.classList.add("splitted");
        }
      }
    });

    // Обновляем видимость "помощника" (кнопки "Еще")
    if (
      menuHelper.querySelector(
        ".menu-level-1 > li:not(.splitted):not(.appended-category)"
      )
    ) {
      menuHelper.classList.remove("empty");
      menuWrapper.classList.remove("fitted");
    } else {
      menuHelper.classList.add("empty");
      menuWrapper.classList.add("fitted");
    }
  }, 100);
};
shoptet.menu.splitMenu = splitMenu;

// CAROUSEL
const handleCarousel = () => {
  const carousel = document.querySelector("#carousel .carousel-inner");
  if (carousel) {
    let observer = new MutationObserver((mutationList) => {
      let currentItem;
      mutationList.forEach((mutation) => {
        if (mutation.target.className === "item active") {
          currentItem = mutation.target;
        }
      });
      if (typeof currentItem == "undefined") return;
      let actualIndex = [
          ...document.querySelectorAll(".carousel-inner .item"),
        ].indexOf(currentItem),
        dotsList = document.querySelectorAll(".carousel-dots li");
      dotsList.forEach((dot) => {
        dot.classList.remove("dot-active");
      });
      dotsList[actualIndex].classList.add("dot-active");
    });
    let dotsCounter = 0,
      dotsList = document.createElement("ul");
    dotsList.classList.add("carousel-dots");
    carousel.querySelectorAll(".item").forEach((item, index) => {
      dotsCounter += 1;
      let dotEl = document.createElement("li");
      dotsList.appendChild(dotEl);
      if (index === 0) dotEl.classList.add("dot-active");
      dotEl.addEventListener("click", (e) => {
        e.preventDefault();
        document
          .querySelector(".carousel-inner .item.active")
          .classList.remove("active");
        let targetItem = document.querySelectorAll(".carousel-inner .item")[
          index
        ];
        const targetItemImg = targetItem.querySelector("img");
        if (!targetItemImg.src)
          targetItemImg.src = targetItemImg.getAttribute("data-src");
        targetItem.classList.add("active");
      });
      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
    if (window.innerWidth <= 767) {
      let carouselTextsMinHeight = 0;
      const carouselTexts = carousel.querySelectorAll(".extended-banner-texts");
      const carouselHelper = document.createElement("div");
      carouselHelper.id = "carousel";
      document.body.appendChild(carouselHelper);
      carouselTexts.forEach((texts) => {
        const clone = texts.cloneNode(true);
        carouselHelper.appendChild(clone);
        if (clone.offsetHeight > carouselTextsMinHeight) {
          carouselTextsMinHeight = clone.offsetHeight;
        }
      });
      carouselHelper.remove();
      carousel.parentElement.style.setProperty(
        `--min-texts-height`,
        `${carouselTextsMinHeight}px`
      );
    }
    carousel.appendChild(dotsList);
  }
};
// handleCarousel();
const handleHomepageProducts = async () => {
  const productBlocks = document.querySelectorAll(".products-block");
  if (window.innerWidth < 768) {
    productBlocks.forEach((block) => {
      $(block).slick({
        slidesToShow: 1.2,
        infinite: false,
        arrows: false,
      });
    });
  }
};
if (dataLayer[0].shoptet.pageType === "homepage") handleHomepageProducts();
// FLAGS
const handleFlags = (product) => {
  const flagsDefault = product.querySelector(".flags-default");
  const flagsExtra = product.querySelector(".flags-extra");
  const priceStandard = product.querySelector(".price-standard");
  const prices = product.querySelector(".prices");
  if (priceStandard && prices) prices.prepend(priceStandard);
  // if (window.innerWidth <= 767) {
  // if (flagsDefault && flagsExtra) {
  // 	flagsDefault.appendChild(flagsExtra)
  // 	flagsDefault.classList.add('contains-extra')
  // }
  // }
};
// RATINGS
const handleRatings = (product) => {
  if (product.querySelector(".custom-ratings")) return;

  const ratingsValue = product.querySelector(".stars-wrapper");
  const productImage = product.querySelector(".image");
  if (!ratingsValue || !productImage) return;

  const rating = parseInt(
    ratingsValue.getAttribute("data-micro-rating-value") || 0
  );
  if (rating === 0) return;

  const customRatings = document.createElement("div");
  customRatings.classList.add("custom-ratings", "stars");
  customRatings.innerHTML = `
    ${rating} <span class="star star-on"></span>
  `;
  productImage.appendChild(customRatings);
};

// AVAILABILITY
const handleProductAvailability = (product) => {
  const availability = product.querySelector(".availability");
  const pBottom = product.querySelector(".p-bottom > div");
  const pPrices = product.querySelector(".p-bottom .prices");
  const existingAvailPrices = product.querySelector(".availability-prices");
  if (availability && pBottom && pPrices && !existingAvailPrices) {
    const pBottomAvailPrices = document.createElement("div");
    pBottomAvailPrices.classList.add("availability-prices");
    pBottomAvailPrices.appendChild(availability);
    pBottomAvailPrices.appendChild(pPrices);
    pBottom.prepend(pBottomAvailPrices);
  }
};
const handleProductAddToCartButton = (product) => {
  const addToCartButton = product.querySelector(".add-to-cart-button > span");
  if (addToCartButton)
    addToCartButton.innerText = window.mmLanguage === "sk" ? "Kúpiť" : "Koupit";
};

const moveAddToFavorites = (product) => {
  if (product.getAttribute("data-favoriteModified") === "true") return;
  const addToFavoritesWrap = product.querySelector(".dkLabFavouriteProductDiv");
  const pImage = product.querySelector(".image");
  if (!addToFavoritesWrap || !pImage) return;
  product.setAttribute("data-favoriteModified", "true");
  pImage.append(addToFavoritesWrap);
  addToFavoritesWrap.addEventListener("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
  });
};
// VZORKY A CENU ZA MERNOU JEDNOTKU
const addVzorkyBtnToProduct = async (product) => {
  const skuSpan = product.querySelector('span[data-micro="sku"]');
  const productCode = skuSpan?.innerText.trim();
  if (!productCode) return;

  try {
    const response = await fetch(
      `https://vpodlahy.mirandamedia.io/api/eshop/product-with-sample/code/${productCode}`
    );
    if (response.ok) {
      const data = await response.json();
      if (data.hasSample && !product.querySelector(".vzorky-button")) {
        const sampleVariant = data.sample.variants?.[0];
        if (sampleVariant) {
          const newVzorkyBtn = document.createElement("button");
          newVzorkyBtn.classList.add("vzorky-button", "btn", "btn-secondary");
          newVzorkyBtn.innerText = "Vzorek";
          newVzorkyBtn.addEventListener("click", () => {
            if (!window.shoptet?.cartShared) return;

            shoptet.cartShared.addToCart({
              productCode: sampleVariant.code,
              amount: 1,
            });
            // alert("Образец добавлен в корзину!");
          });
          const pTools = product.querySelector(".p-tools");
          if (pTools) pTools.prepend(newVzorkyBtn);
        }
      }
    }
  } catch (err) {
    console.error("Error:", err);
  }

  try {
    const response = await fetch(
      `https://vpodlahy.mirandamedia.io/api/eshop/product-unit/code/${productCode}`
    );
    if (response.ok) {
      const data = await response.json();
      // console.log("Product unit data:", data);
      if (data.enabled && data.measurePrice && data.measureUnitText) {
        const pricePerMeasureUnitEl = document.createElement("span");
        pricePerMeasureUnitEl.classList.add("price-measure");
        const price = Number(data.measurePrice);
        const vat = Number(data.vatRate);
        const total = price * (1 + vat / 100);

        const roundedTotal = Math.round(total);
        let unitText = data.measureUnitText.replace(/m2/g, "m²");

        pricePerMeasureUnitEl.innerText = `${roundedTotal.toLocaleString(
          "cs-CZ"
        )} Kč / ${unitText}`;
        const pricesEl = product.querySelector(".prices");
        if (pricesEl) pricesEl.appendChild(pricePerMeasureUnitEl);
      }
    }
  } catch (e) {
    console.error("Error adding price per measure unit:", e);
  }
};
const handleRoundedPrice = async (product) => {
  const priceFinalEl = product.querySelector(".price-final");
  if (!priceFinalEl) return;

  const strongEl = priceFinalEl.querySelector("strong");
  if (!strongEl) return;

  // "4 840,33 Kč" → 4840.33
  const raw = strongEl.textContent
    .replace(/\s/g, "") // убрать пробелы
    .replace("Kč", "") // убрать валюту
    .replace(",", "."); // запятая → точка

  const price = parseFloat(raw);

  if (!isNaN(price)) {
    const rounded = Math.round(price); // обычное округление
    strongEl.textContent = `${rounded.toLocaleString("cs-CZ")} Kč`;
  }
};

const mmAllProducts = document.querySelectorAll(
  ".products-block .product:not(.banner-category)"
);
if (mmAllProducts.length) {
  // mmAllProducts.forEach((product) => handleFlags(product))
  // mmAllProducts.forEach((product) => {
  // 	handleRatings(product)
  // })
  // mmAllProducts.forEach((product) => handleProductAddToCartButton(product))
  // mmAllProducts.forEach((product) => addVzorkyBtnToProduct(product))
  // mmAllProducts.forEach((product) => {
  // 	window.waitFor('.dkLabFavouriteProductDiv').then(() => {
  // 		moveAddToFavorites(product)
  // 	})
  // })
  mmAllProducts.forEach((product) => {
    handleFlags(product);
    handleRatings(product);
    handleProductAddToCartButton(product);
    addVzorkyBtnToProduct(product);
    window.waitForIn(product, ".dkLabFavouriteProductDiv").then(() => {
      moveAddToFavorites(product);
    });
    handleRoundedPrice(product);
  });
}
document.addEventListener("ShoptetDOMContentLoaded", () => {
  const mmAllProducts = document.querySelectorAll(
    ".products-block .product:not(.banner-category)"
  );
  if (mmAllProducts.length) {
    mmAllProducts.forEach((product) => {
      handleFlags(product);
      handleRatings(product);
      handleProductAvailability(product);
      handleProductAddToCartButton(product);
      addVzorkyBtnToProduct(product);
      window.waitForIn(product, ".dkLabFavouriteProductDiv").then(() => {
        moveAddToFavorites(product);
      });
      handleRoundedPrice(product);
    });
  }
});

// --- BLOG HELPERS ---
function processBlogImage(post) {
  const img = post.querySelector(".image img");
  if (img) {
    const src = img.getAttribute("data-src");
    if (src) img.src = src;
  }
}

function createReadMoreButton(post, label = "Přečíst") {
  const title = post.querySelector(".title");
  if (!title) return null;
  const btn = title.cloneNode();
  btn.classList.remove("title");
  btn.classList.add("btn-read-more");
  btn.innerHTML = "";
  const span = document.createElement("span");
  span.innerText = label;
  btn.appendChild(span);
  return btn;
}

function handleBlogPost(post) {
  const postTime = post.querySelector("time");
  const postText = post.querySelector(".text");
  if (postTime && postText) postText.prepend(postTime);
  const btn = createReadMoreButton(post);
  if (btn && postText) postText.appendChild(btn);
}

function handleCategoryBlogPost(post) {
  const desc = post.querySelector(".description");
  if (desc) desc.remove();
  const btn = createReadMoreButton(post);
  if (btn) post.appendChild(btn);
}

function initBlogSlider(wrapper) {
  if (window.innerWidth < 768) {
    if (!$(wrapper).hasClass("slick-initialized")) {
      $(wrapper).slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
      });
    }
  } else {
    if ($(wrapper).hasClass("slick-initialized")) {
      $(wrapper).slick("unslick");
    }
  }
}

// --- BLOG ON HOMEPAGE ---
async function fetchBlogPosts(url = "/blog/", count = 3) {
  const response = await fetch(url);
  const data = await response.text();
  const doc = new DOMParser().parseFromString(data, "text/html");
  const posts = doc.querySelectorAll(".news-item");
  if (!posts.length) return [];
  const result = [];
  for (let i = 0; i < count; i++) {
    if (posts[i]) {
      processBlogImage(posts[i]);
      result.push(posts[i]);
    }
  }
  return result;
}

window.mmHandleBlogPost = handleBlogPost;

document.querySelectorAll(".news-item").forEach(handleBlogPost);

if (dataLayer[0]?.shoptet?.pageType === "homepage") {
  (async () => {
    const blogWrapper = document.createElement("div");
    blogWrapper.classList.add("blog-wrapper", "container");
    const blogPostsWrapper = document.createElement("div");
    blogPostsWrapper.id = "newsWrapper";
    const blogHeadingEl = document.createElement("h2");
    blogHeadingEl.classList.add("homepage-group-title", "blog-title");
    blogHeadingEl.innerHTML =
      typeof blogNadpis !== "undefined" ? blogNadpis : "Poslední články";
    blogWrapper.append(blogHeadingEl, blogPostsWrapper);

    const whereToInsert =
      document.querySelector(".homepage-box.welcome-wrapper") ||
      document.querySelector(".category-content-wrapper");
    if (whereToInsert?.parentElement) {
      whereToInsert.parentElement.insertBefore(blogWrapper, whereToInsert);
    }

    if (sessionStorage.getItem("blogPosts")) {
      blogPostsWrapper.innerHTML = sessionStorage.getItem("blogPosts");
      blogPostsWrapper.querySelectorAll(".news-item").forEach(handleBlogPost);
    } else {
      const blogPosts = await fetchBlogPosts("/blog/", 3);
      blogPosts.forEach((post) => {
        handleBlogPost(post);
        blogPostsWrapper.appendChild(post);
      });
      // sessionStorage.setItem("blogPosts", blogPostsWrapper.innerHTML);
    }

    const toBlogButtonWrapper = document.createElement("div");
    toBlogButtonWrapper.classList.add("buttons-wrapper", "buttons-center");
    const toBlogButton = document.createElement("a");
    toBlogButton.classList.add("btn", "btn-secondary");
    toBlogButton.href = "/blog/";
    toBlogButton.innerHTML =
      window.mmLanguage === "sk" ? "Zobraziť blog" : "Zobrazit vše";
    toBlogButtonWrapper.appendChild(toBlogButton);
    blogWrapper.appendChild(toBlogButtonWrapper);

    // initBlogSlider(blogPostsWrapper);
    // window.addEventListener("resize", () => initBlogSlider(blogPostsWrapper));
  })();
}

// --- BLOG FOR CATEGORY PAGE ---
async function fetchCategoryBlogPosts(url = "/blog/", count = 4) {
  const response = await fetch(url);
  const data = await response.text();
  const doc = new DOMParser().parseFromString(data, "text/html");
  const posts = doc.querySelectorAll(".news-item");
  if (!posts.length) return [];
  const result = [];
  for (let i = 0; i < count; i++) {
    if (posts[i]) {
      processBlogImage(posts[i]);
      result.push(posts[i]);
    }
  }
  return result;
}
async function initCategoryBlogSection() {
  const blogWrapper = document.createElement("div");
  blogWrapper.classList.add("blog-wrapper");
  const blogPostsWrapper = document.createElement("div");
  blogPostsWrapper.id = "newsWrapper";
  const blogHeadingEl = document.createElement("h2");
  blogHeadingEl.classList.add("homepage-group-title", "blog-title");
  blogHeadingEl.innerHTML = "Co se u nás děje";
  blogWrapper.append(blogHeadingEl, blogPostsWrapper);

  const whereToInsert =
    document.querySelector(".category-content-wrapper") ||
    document.querySelector(".homepage-box.welcome-wrapper");
  if (whereToInsert?.parentElement) {
    whereToInsert.parentElement.insertBefore(
      blogWrapper,
      whereToInsert.nextSibling
    );
  }

  if (sessionStorage.getItem("categoryBlogPosts")) {
    blogPostsWrapper.innerHTML = sessionStorage.getItem("categoryBlogPosts");
    blogPostsWrapper
      .querySelectorAll(".news-item")
      .forEach(handleCategoryBlogPost);
  } else {
    const blogPosts = await fetchCategoryBlogPosts("/blog/", 4);
    blogPosts.forEach((post) => {
      handleCategoryBlogPost(post);
      blogPostsWrapper.appendChild(post);
    });
    // sessionStorage.setItem("categoryBlogPosts", blogPostsWrapper.innerHTML);
  }

  initBlogSlider(blogPostsWrapper);
  window.addEventListener("resize", () => initBlogSlider(blogPostsWrapper));
}
if (dataLayer[0]?.shoptet?.pageType === "category") {
  initCategoryBlogSection();
  document.addEventListener("ShoptetDOMContentLoaded", () => {
    initCategoryBlogSection();
  });
}

function hideClanekOnMobile() {
  const buttons = [
    document.querySelector('[data-testid="buttonNextArticle"]'),
    document.querySelector('[data-testid="buttonPreviousArticle"]'),
  ];

  buttons.forEach((btn) => {
    if (btn) {
      btn.textContent = btn.textContent.replace("článek", "").trim();
    }
  });
}

if (dataLayer[0]?.shoptet?.pageType === "article") {
  hideClanekOnMobile();
}

const handleUSP = async () => {
  let benefitBanner = document.querySelector(".benefitBanner");

  const blogWrapper = document.querySelector(".blog-wrapper");
  if (blogWrapper) blogWrapper.after(benefitBanner);
};
if (dataLayer[0].shoptet.pageType === "homepage") {
  handleUSP();
}
// FOOTER-BOTTOM
const footerBottom = document.querySelector(".footer-bottom");
const footerGlobal = document.querySelector("#footer");
if (footerBottom && footerGlobal) {
  const footerBottomWrapper = document.createElement("div");
  footerBottomWrapper.classList.add("footer-bottom-wrapper");
  footerBottomWrapper.appendChild(footerBottom);
  footerGlobal.parentElement.insertBefore(
    footerBottomWrapper,
    footerGlobal.nextElementSibling
  );
  const signature = footerBottom.querySelector("#signature");
  if (signature) {
    signature.style.display = "flex";
    // 	const mirandaEl = document.createElement('a')
    // 	mirandaEl.href = 'https://www.mirandamedia.cz/'
    // 	mirandaEl.target = '_blank'
    // 	mirandaEl.innerHTML = 'Partner: MirandaMedia s.r.o.'
    // 	signature.appendChild(mirandaEl)
    // const platebniMetodyEl = document.createElement("img");
    // // platebniMetodyEl.src = "/user/documents/upload/miranda/platebni_metody.png";
    // platebniMetodyEl.alt = "Platební metody";
    // signature.parentElement.insertBefore(
    //   platebniMetodyEl,
    //   signature.nextElementSibling
    // );
  }
}

// PRODUCT DETAIL
const createShpTabLink = (text, anchor) => {
  const shpTabLi = document.createElement("li");
  const shpTabLink = document.createElement("a");
  shpTabLi.classList.add("shp-tab");
  shpTabLi.appendChild(shpTabLink);
  shpTabLink.classList.add("shp-tab-link");
  shpTabLink.href = anchor;
  shpTabLink.innerHTML = text;
  return shpTabLi;
};
if (document.body.classList.contains("type-detail")) {
  const pDetailTabs = document.querySelector("#p-detail-tabs");
  const tabContent = document.querySelector("#tab-content");

  // const customMobileSlider = document.querySelector('.custom-slider-wrapper')
  // if (customMobileSlider)
  // 	$(customMobileSlider).slick({
  // 		infinite: false,
  // 		arrows: false,
  // 		slidesToShow: 1.2,
  // 		slidesToScroll: 1,
  // 		dots: true,
  // 	})

  // DLOUHY POPIS + OSTATNI TABY
  // const shpTabLinks = document.querySelectorAll('.shp-tab-link')
  // if (shpTabLinks.length) {
  // 	shpTabLinks.forEach((link) => {
  // 		link.removeAttribute('role')
  // 		link.removeAttribute('data-toggle')
  // 	})
  // }
  const parametersTabContent = document.querySelector(
    "#description .extended-description"
  );
  const descriptionTab = document.querySelector(
    '.shp-tab[data-testid="tabDescription"]'
  );

  if (parametersTabContent && descriptionTab) {
    if (parametersTabContent) {
      const ratingTabHeading = parametersTabContent.querySelector("h3");
      ratingTabHeading.innerHTML = "Technická specifikace";
    }
    if (window.innerWidth <= 767) {
      // const parametersTab = createShpTabLink('Specifikace', '#parameters')
      const parametersTab = descriptionTab.cloneNode(true);
      parametersTab.classList.remove("active");
      descriptionTab.after(parametersTab);
      // parametersTabContent.id = 'parameters'
      const parametersLink = parametersTab.querySelector(".shp-tab-link");
      parametersLink.innerText = "Technická specifikace";
      parametersLink.href = "#parameters";
      const description = document.querySelector("#description");
      if (description) {
        const descClone = description.cloneNode(true);
        description.after(descClone);
        descClone.id = "parameters";
        descClone.classList.remove("active");
        const paramInDesc = description.querySelector(".extended-description");
        const descInParam = descClone.querySelector(".basic-description");
        if (paramInDesc) paramInDesc.remove();
        if (descInParam) descInParam.remove();
      }
    } else {
      const parametersTab = createShpTabLink(
        "Technická specifikace",
        "#parameters"
      );

      descriptionTab.after(parametersTab);
      parametersTabContent.id = "parameters";
    }
  }

  // const ratingTab = document.querySelector("#ratingTab");
  // if (ratingTab) {
  //   const ratingTabHeading = document.createElement("h3");
  //   ratingTabHeading.innerHTML = "Hodnocení";
  //   ratingTab.prepend(ratingTabHeading);
  // }
  // const discussionTab = document.querySelector("#productDiscussion");
  // if (discussionTab) {
  //   const discussionHeading = document.createElement("h3");
  //   discussionHeading.innerHTML = "Diskuze";
  //   discussionTab.prepend(discussionHeading);
  // }
  const relatedFiles = document.querySelector("#relatedFiles");
  if (relatedFiles) {
    const relatedFilesHeading = document.createElement("h3");
    relatedFilesHeading.innerHTML = "Ke stažení";
    relatedFiles.prepend(relatedFilesHeading);
  }
  const extendedDescTable = document.querySelector(
    ".extended-description .detail-parameters"
  );
  if (extendedDescTable) {
    const extendedDescThead = document.createElement("thead");
    const extendedDescTr = document.createElement("tr");
    const extendedDescTh = document.createElement("th");
    extendedDescTh.innerHTML = "Rozměry";

    extendedDescTr.appendChild(extendedDescTh);
    extendedDescThead.appendChild(extendedDescTr);
    extendedDescTable.prepend(extendedDescThead);
  }

  const relatedProducts = document.querySelector(".products-related");
  const relatedProductsHeading = document.querySelector(
    ".products-related-header"
  );
  // if (relatedProducts && relatedProductsHeading) {
  //   // const relatedProductsCount = relatedProducts.querySelectorAll('.product').length
  //   // const relatedProductsLink = createShpTabLink(`Další produkty`, '#relatedProducts')
  //   // pDetailTabs.appendChild(relatedProductsLink)
  //   relatedProductsHeading.classList.add("homepage-group-title");
  //   relatedProductsHeading.innerHTML = `Příslušenství k tomuto produktu`;
  //   const relatedProductsTab = document.createElement("div");
  //   // relatedProductsTab.classList.add('tab-pane')
  //   relatedProductsTab.id = "relatedProducts";
  //   relatedProductsTab.classList.add("full-width");
  //   const relatedProductsContainer = document.createElement("div");
  //   relatedProductsContainer.classList.add("container");
  //   relatedProductsTab.appendChild(relatedProductsContainer);
  //   relatedProductsContainer.appendChild(relatedProductsHeading);
  //   relatedProductsContainer.appendChild(relatedProducts);
  //   // tabContent.appendChild(relatedProductsTab)
  //   const productContent = document.querySelector("#content");
  //   productContent.appendChild(relatedProductsTab);
  if (!relatedProducts?.classList.contains("slick-initialized")) {
    $(relatedProducts).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 1.2, arrows: false } },
      ],
    });
  }
  const productsAlternative = document.querySelector(".products-alternative ");
  if (!productsAlternative?.classList.contains("slick-initialized")) {
    $(productsAlternative).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 1.2, arrows: false } },
      ],
    });
  }
  //   const relatedThumbnail = document.createElement("div");
  //   relatedThumbnail.classList.add("related-thumbnail");
  //   const thumbnailInfo = document.createElement("div");
  //   thumbnailInfo.classList.add("thumbnail-info");
  //   relatedThumbnail.appendChild(thumbnailInfo);
  //   const thumbnailName = document.querySelector(".p-detail-inner-header h1");
  //   if (thumbnailName) {
  //     const thumbnailNameClone = document.createElement("div");
  //     thumbnailNameClone.innerHTML = thumbnailName.innerHTML;
  //     thumbnailInfo.appendChild(thumbnailNameClone);
  //     thumbnailNameClone.classList.add("p-name");
  //   }
  //   const thumbnailPrice = document.querySelector(
  //     ".p-info-wrapper .price-final"
  //   );
  //   if (thumbnailPrice)
  //     thumbnailInfo.appendChild(thumbnailPrice.cloneNode(true));
  //   const thumbnailImage = document.querySelector(".p-thumbnail img");
  //   if (thumbnailImage) {
  //     const thumbnailImageEl = thumbnailImage.cloneNode(true);
  //     relatedThumbnail.appendChild(thumbnailImageEl);
  //     thumbnailImageEl.setAttribute(
  //       "data-src",
  //       thumbnailImageEl
  //         .getAttribute("data-src")
  //         .replace("/related/", "/detail/")
  //     );
  //     thumbnailImageEl.src = thumbnailImageEl.src.replace(
  //       "/related/",
  //       "/detail/"
  //     );
  //   }
  //   relatedProductsContainer.prepend(relatedThumbnail);
  // }

  const alternativeProductsTabLink = document.querySelector(
    '.shp-tab-link[href="#productsAlternative"]'
  );
  if (alternativeProductsTabLink)
    alternativeProductsTabLink.parentElement.remove();
  const alternativeProducts = document.querySelector("#productsAlternative");
  if (alternativeProducts) {
    const alternativeProductsHeading = document.createElement("h2");
    alternativeProductsHeading.classList.add("homepage-group-title");
    alternativeProducts.classList.remove("tab-pane", "fade");
    if (!document.body.classList.contains("discontinued-product")) {
      alternativeProductsHeading.innerHTML = "Podobné produkty";
      const productContent = document.querySelector("#content");
      // const helpUSP = document.querySelector('#content > .benefitBanner')
      // if (helpUSP) {
      // 	helpUSP.parentElement.insertBefore(alternativeProductsHeading, helpUSP)
      // 	helpUSP.parentElement.insertBefore(alternativeProducts, helpUSP)
      // } else {
      productContent.appendChild(alternativeProductsHeading);
      productContent.appendChild(alternativeProducts);
      // }
    }
  }
  const shpTabLinks = document.querySelectorAll(".shp-tab-link");
  if (shpTabLinks.length) {
    shpTabLinks.forEach((link) => {
      link.removeAttribute("role");
      link.removeAttribute("data-toggle");
    });
  }
  // const shpTabLinks = document.querySelectorAll(".shp-tab-link");

  shpTabLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      document.querySelectorAll(".shp-tab").forEach((tab) => {
        tab.classList.remove("active");
      });

      this.parentElement.classList.add("active");
    });
  });

  if (document.body.classList.contains("discontinued-product")) {
    const firstCategory = document.querySelector(
      ".breadcrumbs #navigation-1 a"
    );
    if (firstCategory) {
      const firstCategoryMenu = document.querySelector(
        '.menu-level-1 > li > a[href="' +
          firstCategory.getAttribute("href") +
          '"]'
      );
      if (firstCategoryMenu) {
        const menuToCopy = firstCategoryMenu
          .closest("li")
          .querySelector(".menu-level-2");
        const productsAlternative =
          document.querySelector("#productsAlternative") ||
          document.querySelector(".p-detail-inner");
        if (menuToCopy && productsAlternative) {
          const menuClone = menuToCopy.cloneNode(true);
          menuClone.classList.remove("menu-level-2");
          menuClone.classList.add("alternative-categories");
          productsAlternative.parentElement.insertBefore(
            menuClone,
            productsAlternative.nextElementSibling
          );
          if (typeof kategorie404Nadpis != "undefined") {
            const menuTitle = document.createElement("h2");
            menuTitle.classList.add("homepage-group-title");
            menuTitle.innerHTML = kategorie404Nadpis;
            menuClone.parentElement.insertBefore(menuTitle, menuClone);
          }
          if (typeof kategorie404Perex != "undefined") {
            const menuPerex = document.createElement("p");
            menuPerex.innerHTML = kategorie404Perex;
            menuClone.parentElement.insertBefore(menuPerex, menuClone);
          }
        }
      }
    }
  }

  // const watchdogButton = document.querySelector(".link-icon.watchdog");
  // if (watchdogButton) watchdogButton.title = "Hlídat cenu a dostupnost";
}

// CART
const handleCart = async () => {
  const pageHeader = document.querySelector("#header");
  const cartHeader = document.querySelector(".cart-content .cart-header");
  const cartHeaderHelper = document.querySelector(".cart-header-wrapper");

  if (cartHeader && !cartHeaderHelper) {
    const cartHeaderWrapper = document.createElement("div");
    cartHeaderWrapper.classList.add("cart-header-wrapper", "container");
    cartHeaderWrapper.appendChild(cartHeader);

    // cartHeader.classList.add("container");
    pageHeader.parentElement.insertBefore(
      cartHeaderWrapper,
      pageHeader.nextElementSibling
    );
  } else if (cartHeader) {
    cartHeader.remove();
  }

  const showRelatedProducts = document.querySelectorAll(
    ".p-name .show-related"
  );
  // if (showRelatedProducts.length) {
  //   showRelatedProducts.forEach((button) => {
  //     button.innerHTML = button.innerHTML.replace(
  //       "Související produkty",
  //       "Doporučené příslušenství"
  //     );
  //   });
  // }

  if (
    typeof kosikKontakt !== "undefined" &&
    !document.querySelector("#header .cart-contact")
  ) {
    const cartContact = document.createElement("div");
    cartContact.innerHTML = kosikKontakt;
    const siteNameWrapper = document.querySelector(".site-name-wrapper");
    siteNameWrapper.parentElement.insertBefore(
      cartContact,
      siteNameWrapper.nextElementSibling
    );
  }

  const sidebarCart = document.querySelector(".sidebar-in-cart");
  const summaryWrapper = document.querySelector(".summary-wrapper");
  // const sidebarCart = document.querySelector('.sidebar-in-cart .box[data-testid="tableCart"]')
  const extraDelivery = document.querySelector(".extra.delivery");
  if (extraDelivery && sidebarCart) {
    if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0)
      extraDelivery.classList.add("free-shipping");
    summaryWrapper.prepend(extraDelivery);
    // sidebarCart.prepend(extraDelivery)
  }

  const discountForm = document.querySelector(".discount-coupon");
  if (discountForm && summaryWrapper) {
    summaryWrapper.prepend(discountForm);
    const discountInput = discountForm.querySelector("input");
    discountInput.placeholder = "Slevový kód";
  }
  const nextStepBack = document.querySelector(".next-step-back");
  const cartInner = document.querySelector(".cart-inner");
  // if cart inner has nextStepBack, move nextStepBack after cartInner
  if (nextStepBack && cartInner && cartInner.contains(nextStepBack)) {
    cartInner.insertAdjacentElement("afterend", nextStepBack);
  }

  const overallWrapper = document.querySelector(".overall-wrapper");
  const cartFooter = document.querySelector(".cart-footer");
  if (!cartFooter) {
    const cartFooter = document.createElement("div");
    cartFooter.classList.add("cart-footer");
    if (overallWrapper) overallWrapper.appendChild(cartFooter);
    cartFooter.innerHTML = `    <div class="footer-bottom-wrapper">
      <div class="container footer-bottom">
        <span id="signature" style="display: flex; visibility: visible !important;">
          <a href="https://www.shoptetpremium.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="image" target="_blank">
            <img src="https://cdn.myshoptet.com/prj/dist/master/cms/img/shoptetPremiumLogo.svg" width="17" height="17" alt="Shoptet Premium" class="vam" loading="lazy">
          </a>
          <a href="https://www.shoptetpremium.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="title" target="_blank">
            Vytvořil Shoptet Premium
          </a>
        
        </span>
        <span class="copyright" data-testid="textCopyright">
          Copyright 2025 <strong>V-PODLAHY, s.r.o</strong>. Všechna práva vyhrazena.
          <a href="#" class="cookies-settings js-cookies-settings" data-testid="cookiesSettings">Upravit nastavení cookies</a>
        </span>
      </div>
    </div>
`;
  }
  const sidebarNextStep = document.querySelector("#checkoutSidebar .next-step");
  const orderSummary = document.querySelector("#summary-box");
  if (sidebarNextStep && orderSummary)
    orderSummary.appendChild(sidebarNextStep);
  if (
    window.innerWidth <= 767 &&
    (document.body.classList.contains("in-krok-1") ||
      document.body.classList.contains("in-krok-2"))
  ) {
    if (sidebarNextStep) sidebarNextStep.after(nextStepBack);
  }
  const sidebarConsents = document.querySelectorAll(
    "#checkoutSidebar .consents"
  );
  const summaryItemPrice = document.querySelector(
    "#checkoutSidebar .order-summary-item.price"
  );
  if (sidebarConsents.length && summaryItemPrice) {
    sidebarConsents.forEach((consent) => {
      summaryItemPrice.parentElement.insertBefore(
        consent,
        summaryItemPrice.nextElementSibling
      );
    });
  }

  // const backToShopButtons = document.querySelectorAll('.back-to-shop')
  // if (backToShopButtons.length) {
  // 	backToShopButtons.forEach((button) => {
  // 		button.innerText = 'Zpět do obchodu'
  // 	})
  // }
  const paymentInfoTooltips = document.querySelectorAll(
    ".payment-info .show-tooltip"
  );
  if (paymentInfoTooltips.length) {
    paymentInfoTooltips.forEach((tooltip) => {
      tooltip.innerText = "i";
    });
  }
  const handleFreeRecapitulation = () => {
    setTimeout(() => {
      const recapItemPrices = document.querySelectorAll(
        ".recapitulation-shipping-billing-info > span"
      );
      if (recapItemPrices.length) {
        recapItemPrices.forEach((price) => {
          if (price.innerText.toUpperCase().includes("ZDARMA")) {
            price.classList.add("for-free");
          } else {
            price.classList.remove("for-free");
          }
        });
      }
    }, 100);
  };
  document.addEventListener(
    "ShoptetShippingMethodUpdated",
    handleFreeRecapitulation
  );
  document.addEventListener(
    "ShoptetBillingMethodUpdated",
    handleFreeRecapitulation
  );

  const recapItemPrices = document.querySelectorAll(
    'span[data-testid="recapItemPrice"]'
  );
  if (recapItemPrices.length) {
    recapItemPrices.forEach((price) => {
      if (price.innerText.toUpperCase().includes("ZDARMA")) {
        price.classList.add("for-free");
      } else {
        price.classList.remove("for-free");
      }
    });
  }

  const continueOrderButton =
    document.querySelector("#orderFormButton") ||
    document.querySelector("#continue-order-button");
  if (continueOrderButton) {
    continueOrderButton.innerText = "Pokračovat v objednávce";
  }

  const relatedProductsBuyButton = document.querySelectorAll(
    ".cart-related-product .add-to-cart-button"
  );
  if (relatedProductsBuyButton.length) {
    relatedProductsBuyButton.forEach((button) => {
      button.innerText = "Koupit";
    });
  }

  // const footerCheck = document.querySelector(".ordering-process-footer");
  // if (!footerCheck) {
  //   const cartProjectMail = document.querySelector(".contact-box .mail");
  //   const cartProjectPhone = document.querySelector(".contact-box .tel");
  //   const orderingProcessFooter = document.createElement("footer");
  //   orderingProcessFooter.classList.add("ordering-process-footer");
  //   orderingProcessFooter.innerHTML = `
  // 		<div class="container">
  // 			<div class="secure-payment">
  // 				<span>Bezpečná platba</span>
  // 				<img src="/user/documents/upload/miranda/platebni_metody.png" width="286" height="23" alt="Visa, MasterCard, Maestro, PayPal"/>
  // 			</div>
  // 			<div class="contact-box phone-wrapper">
  // 				<span>${
  //           typeof callCenterHours != null
  //             ? callCenterHours
  //             : "Po–Pá: 9:00–18:30"
  //         }</span>
  // 			</div>
  // 			<div class="contact-box mail-wrapper">
  // 				<span>Reagujeme do 24 hodin</span>
  // 			</div>
  // 		</div>
  // 	`;
  //   overallWrapper.appendChild(orderingProcessFooter);
  //   const orderingProcessFooterPhoneWrapper =
  //     orderingProcessFooter.querySelector(".phone-wrapper");
  //   const orderingProcessFooterMailWrapper =
  //     orderingProcessFooter.querySelector(".mail-wrapper");
  //   if (cartProjectPhone) {
  //     orderingProcessFooterPhoneWrapper.prepend(
  //       cartProjectPhone.cloneNode(true)
  //     );
  //     orderingProcessFooter
  //       .querySelector(".phone-wrapper .tel")
  //       .classList.add("project-phone");
  //   }
  //   if (cartProjectMail) {
  //     orderingProcessFooterMailWrapper.prepend(cartProjectMail.cloneNode(true));
  //     orderingProcessFooter
  //       .querySelector(".mail-wrapper .mail a")
  //       .classList.add("project-email");
  //   }
  // }
  const footerCheck = document.querySelector(".footer-bottom-wrapper");

  if (!footerCheck) {
    console.log("Fetching footer...");
    fetch("/")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const footer = doc.querySelector(".footer-bottom-wrapper");

        console.log("Footer fetched:", footer);
        if (footer) {
          const overallWrapper =
            document.querySelector(".overall-wrapper") || document.body;
          overallWrapper.appendChild(footer.cloneNode(true));
        } else {
          console.warn("Footer not found on the main page.");
        }
      })
      .catch((err) => console.error("Error fetching footer:", err));
  }

  if (dataLayer[0].shoptet.pageType === "cart") {
    const productsInCart = document.querySelectorAll(
      '.cart-table tr.removeable[data-micro="cartItem"]'
    );
    productsInCart.forEach(async (product) => {
      const productCode = product.getAttribute("data-micro-sku");
      let m2InPackage = 0;

      try {
        const response = await fetch(
          `https://vpodlahy.mirandamedia.io/api/eshop/product-unit/code/${productCode}`
        );

        if (response.ok) {
          const data = await response.json();
          m2InPackage = data.packagingAmount || 0;

          if (m2InPackage) {
            const productName = product.querySelector(".unit-value");
            if (productName) {
              if (!productName.querySelector(".product-sku-package")) {
                const amountInput = product.querySelector(
                  'input[name="amount"]'
                );
                const amount = parseInt(amountInput?.value, 10) || 1;
                const totalM2 = parseFloat((m2InPackage * amount).toFixed(4));

                const productSKUEl = document.createElement("div");
                productSKUEl.classList.add(
                  "product-sku",
                  "product-sku-package"
                );
                const unit = data.packagingUnitText;
                const prefix =
                  unit === "m2"
                    ? `v balení ${m2InPackage} m², `
                    : `${m2InPackage} ${unit}, `;
                productSKUEl.innerHTML =
                  unit === "m2"
                    ? ` (${prefix}celkem ${totalM2} m²)`
                    : ` (${prefix}celkem ${totalM2} ${unit})`;
                productName.appendChild(productSKUEl);
              }
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch product data for calculator:", error);
      }
    });
    // const productName = product.querySelector('.p-name')
    // if (productSKU && productName) {
    // 	const productSKUEl = document.createElement('div')
    // 	productSKUEl.classList.add('product-sku')
    // 	productSKUEl.innerHTML = `Kód: ${productSKU}`
    // 	productName.appendChild(productSKUEl)
    // }
    (async () => {
      try {
        const response = await fetch("/objednavka/krok-1/");
        const data = await response.text();
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, "text/html");
        const cartMessage = htmlDocument.querySelector(".site-msg-custom");
        if (cartMessage) {
          const cartSummary = document.querySelector(
            '.summary-wrapper .box[data-testid="tableCart"]'
          );
          if (cartSummary)
            cartSummary.parentElement.insertBefore(cartMessage, cartSummary);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }

  // const setRegistrationCheck = document.querySelector("#set-registration");
  // const loginLabel = document.querySelector('label[for="login"]');
  // console.log(setRegistrationCheck, loginLabel);
  // if (setRegistrationCheck && loginLabel) {
  //   const parent = loginLabel.parentElement;
  //   parent.style.flexDirection = "row";
  //   parent.style.alignItems = "center";
  //   parent.style.marginBottom = "20px";
  //   if (window.innerWidth <= 767) {
  //     parent.style.flexDirection = "column";
  //     parent.style.alignItems = "flex-start";
  //   }
  //   parent.appendChild(setRegistrationCheck.closest(".form-group"));
  // }

  // const newsletterCheckbox = document.querySelector("#sendNewsletter");
  // if (newsletterCheckbox && summaryItemPrice)
  //   summaryItemPrice.parentElement.insertBefore(
  //     newsletterCheckbox.closest(".form-group"),
  //     summaryItemPrice.nextElementSibling
  //   );

  const cartContent = document.querySelector(".cart-content");
  const cartObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList.contains("mehub-bonus-cart-container")) {
          sidebarCart.appendChild(node);
        }
      });
    });
  });
  if (cartContent) cartObserver.observe(cartContent, { childList: true });
};
if (document.body.classList.contains("ordering-process")) {
  handleCart();
  document.addEventListener("ShoptetDOMCartContentLoaded", handleCart);
}

// POPUP CART
document.addEventListener("ShoptetDOMCartContentLoaded", () => {
  const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol;
  const cartWidgetProducts = document.querySelectorAll(".cart-widget-product");
  if (cartWidgetProducts.length) {
    cartWidgetProducts.forEach((product) => {
      const productPrice = product.querySelector(
        'span[data-testid="cartWidgetProductPrice"]'
      );
      if (productPrice) {
        const priceEl = document.createElement("div");
        priceEl.classList.add("cart-widget-product-price");
        priceEl.appendChild(productPrice);
        product.appendChild(priceEl);
        const productSKU = product.getAttribute("data-micro-sku");
        // if (productSKU) {
        // 	const productSinglePrice = dataLayer[0].shoptet.cart.filter((item) => item.code === productSKU)[0].priceWithVat
        // 	const productSinglePriceEl = document.createElement('div')
        // 	productSinglePriceEl.classList.add('cart-widget-product-single-price')
        // 	productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks`
        // 	priceEl.appendChild(productSinglePriceEl)
        // }
      }
    });
  }

  let popupCartSummary = document.querySelector(".popup-cart-summary");
  if (!popupCartSummary) {
    popupCartSummary = document.createElement("div");
    popupCartSummary.classList.add("popup-cart-summary");
  }
  const popupCartSummaryPriveVAT =
    dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat;
  const popupCartSummaryPriceNoVAT =
    dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat;
  // popupCartSummary.innerHTML = `
  // 	<div class="popup-cart-summary-item">
  // 		<strong class="popup-cart-summary-item-label">Celkem</strong>
  // 		<strong class="popup-cart-summary-item-value">${Number(popupCartSummaryPriveVAT).toLocaleString('cs-CZ')} ${currencyLabel}</strong>
  // 	</div>
  // 	`
  // <div class="popup-cart-summary-item">
  // 	<span class="popup-cart-summary-item-label">Celkem bez DPH</span>
  // 	<span class="popup-cart-summary-item-value">${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}</span>
  // </div>
  const cartWidgetProductsWrapper = document.querySelector(
    ".cart-widget-products"
  );
  if (cartWidgetProductsWrapper)
    cartWidgetProductsWrapper.parentElement.insertBefore(
      popupCartSummary,
      cartWidgetProductsWrapper.nextElementSibling
    );

  const cartWidgetButton = document.querySelector(".cart-widget-button");
  const cartWidgetInner = document.querySelector(".cart-widget-inner");
  if (cartWidgetButton && cartWidgetInner)
    cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true));

  const cartWidgetShipping = document.querySelector(".cart-free-shipping");
  if (cartWidgetShipping) {
    const priceLeftToFreeShipping =
      dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft;
    if (priceLeftToFreeShipping > 0) {
      const freeShippingBar = document.createElement("div");
      const freeShippingValue = document.createElement("div");
      freeShippingBar.classList.add("price-range");
      freeShippingBar.appendChild(freeShippingValue);
      freeShippingValue.style.width = `${
        100 -
        (100 * priceLeftToFreeShipping) /
          (priceLeftToFreeShipping + popupCartSummaryPriveVAT)
      }%`;
      cartWidgetShipping.appendChild(freeShippingBar);
      const shippingWidgetStrongs =
        cartWidgetShipping.querySelectorAll("strong");
      if (shippingWidgetStrongs.length) {
        shippingWidgetStrongs.forEach((strong) => {
          if (strong.innerText.includes("ZDARMA"))
            strong.classList.add("free-shipping-strong");
        });
      }
    }
  }
});
// document.addEventListener('ShoptetCartUpdated', () => {
// 	const popupCartSummary = document.querySelector('.popup-cart-summary')
// 	console.log(popupCartSummary)
// 	// const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
// 	// const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
// 	// const popupCartPriceVAT = popupCartSummary.querySelector('strong.popup-cart-summary-item-value')
// 	// const popupCartPriceNoVAT = popupCartSummary.querySelector('span.popup-cart-summary-item-value')
// 	// popupCartPriceVAT.innerHTML = `${popupCartSummaryPriveVAT} ${currencyLabel}`
// 	// popupCartPriceNoVAT.innerHTML = `${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}`
// })

// ADVANCED ORDER
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", () => {
  const advancedOrder = document.querySelector(".advanced-order");
  const aoTop = document.createElement("div");
  aoTop.classList.add("ao-top");
  advancedOrder.prepend(aoTop);
  const aoTitle = advancedOrder.querySelector(".h1");
  if (aoTitle) aoTop.appendChild(aoTitle);
  const aoProduct =
    advancedOrder.querySelector(".ao-product") ||
    advancedOrder.querySelector(".h2");
  if (aoProduct) aoTop.appendChild(aoProduct);
  const cboxClose = document.querySelector("#cboxClose");
  if (cboxClose) {
    cboxClose.innerText = "Zavřít";
    // aoTop.appendChild(cboxClose)
  }
  const continueShoppingBtn = document.createElement("button");
  continueShoppingBtn.classList.add("btn-continue-shopping");
  continueShoppingBtn.innerText = "Pokračovat v nákupu";
  continueShoppingBtn.addEventListener("click", () => {
    shoptet.modal.close();
  });
  const extraStep = advancedOrder.querySelector(".extra.step");
  if (extraStep) extraStep.prepend(continueShoppingBtn);

  const deliveryStrongs = advancedOrder.querySelectorAll(
    ".extra.delivery strong"
  );
  if (deliveryStrongs.length) {
    deliveryStrongs.forEach((strong) => {
      if (strong.innerText === "ZDARMA") strong.classList.add("for-free");
    });
  }
  const suggestionsTitle = advancedOrder.querySelector(
    ".advanced-order-suggestion"
  );
  // if (suggestionsTitle) suggestionsTitle.innerHTML = "Doporučené příslušenství";
});

// EMPTY CART

const handleEmptyCart = () => {
  const emptyCart = document.querySelector(".cart-inner.cart-empty");
  document.body.classList.add("custom-empty-cart");
  const cartHeading = emptyCart.querySelector(".cart-heading");
  const cartText = document.createElement("p");
  cartText.classList.add("narrow-custom", "text-center");
  cartText.innerText = prazdnyKosikPerex;
  if (cartHeading) {
    cartHeading.innerText = prazdnyKosikNadpis;
    cartHeading.classList.add("homepage-group-title");
    cartHeading.parentElement.insertBefore(
      cartText,
      cartHeading.nextElementSibling
    );
  }
  // const cartEmail = emptyCart.querySelector('.mail')
  // const cartPhone = emptyCart.querySelector('.tel')
  // const cartContact = document.createElement('ul')
  // cartContact.classList.add('cart-contact', 'contact-box')
  // if (cartPhone) {
  // 	if (typeof headerOpeningHours !== 'undefined') {
  // 		const phonePerex = document.createElement('span')
  // 		phonePerex.innerText = headerOpeningHours
  // 		cartPhone.parentElement.insertBefore(phonePerex, cartPhone.nextElementSibling)
  // 	}
  // 	cartContact.appendChild(cartPhone.parentElement)
  // }
  // if (cartEmail) {
  // 	const emailPerex = document.createElement('span')
  // 	emailPerex.innerText = 'Odpovídáme do 24 hodin'
  // 	cartEmail.parentElement.insertBefore(emailPerex, cartEmail.nextElementSibling)
  // 	cartContact.appendChild(cartEmail.parentElement)
  // }
  // emptyCart.appendChild(cartContact)
  const backToShopButton = document.createElement("div");
  backToShopButton.classList.add("buttons-wrapper", "buttons-center");
  backToShopButton.innerHTML = `
		<a href="/" class="btn btn-primary btn-lg">Zpět do obchodu</a>
	`;
  emptyCart.appendChild(backToShopButton);
  const emptyCartHeader = document.querySelector(".cart-header-wrapper");
  if (emptyCartHeader) emptyCartHeader.remove();
};
const emptyCart = document.querySelector(".cart-inner.cart-empty");
// if (emptyCart) handleEmptyCart();

// document.addEventListener("ShoptetDOMCartContentLoaded", () => {
//   if (!dataLayer[0].shoptet.cart.length) handleEmptyCart();
// });

// EMPTY CART POPUP
// const handleEmptyCartPopup = () => {
// 	const isEmpty = document.querySelector('.cart-widget .place-cart-here')
// 	if (isEmpty) {
// 		const toggleCart = document.querySelector('.toggle-window.cart-count')
// 		if (toggleCart) {
// 			toggleCart.addEventListener('mouseenter', () => document.body.classList.add('user-action-visible', 'cart-window-visible'))
// 			// toggleCart.addEventListener('mouseleave', () => document.body.classList.remove('user-action-visible', 'cart-window-visible'))
// 		}
// 		const cartLoader = isEmpty.querySelector('.loader-overlay')
// 		if (cartLoader) cartLoader.remove()
// 		const emptyCartPopup = document.createElement('div')
// 		emptyCartPopup.classList.add('empty-cart-popup')

// 		emptyCartPopup.innerHTML = `
// 			<h2>Ve vašem košíku nemáte žádné zboží</h2>
// 			<p>Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte Majyi, která Vám s výběrem velmi ráda pomůže.</p>
// 			<div class="contact-box phone-placeholder">
// 			</div>
// 			<div class="contact-box mail-placeholder">
// 				<span>Odpovídáme do 24 hodin</span>
// 			</div>
// 			<p>Nebo přejděte na naše kategorie</p>
// 			<ul class="subcategories">
// 			</ul>
// 		`
// 		if (typeof emptyCartSubcategories !== 'undefined') {
// 			const subcategoriesWrapper = emptyCartPopup.querySelector('.subcategories')
// 			emptyCartSubcategories.forEach((subcategory) => {
// 				const subcategoryEl = document.createElement('li')
// 				subcategoryEl.innerHTML = `
// 					<a href="${subcategory.link}">
// 						<span class="text">${subcategory.text}</span>
// 						<span class="image">
// 							<img src="${subcategory.image}" alt="" />
// 						</span>
// 					</a>
// 				`
// 				subcategoriesWrapper.appendChild(subcategoryEl)
// 			})
// 		}
// 		isEmpty.appendChild(emptyCartPopup)
// 		const projectMail = document.querySelector('.contact-box .mail')
// 		const projectPhone = document.querySelector('.contact-box .tel')
// 		const phonePlaceholder = emptyCartPopup.querySelector('.phone-placeholder')
// 		const mailPlaceholder = emptyCartPopup.querySelector('.mail-placeholder')
// 		if (projectPhone) {
// 			phonePlaceholder.appendChild(projectPhone.cloneNode(true))
// 			// if (headerOpeningHours) {
// 			// 	const phonePerex = document.createElement('span')
// 			// 	phonePerex.innerText = headerOpeningHours
// 			// 	phonePlaceholder.appendChild(phonePerex)
// 			// }
// 		}
// 		if (projectMail) {
// 			mailPlaceholder.prepend(projectMail.cloneNode(true))
// 		}
// 	}
// }
// handleEmptyCartPopup()
const toggleCategoryHover = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const categoryHover = document.querySelector("#category-filter-hover");
  if (!categoryHover) return;

  const currentDisplay = window.getComputedStyle(categoryHover).display;
  categoryHover.style.display = currentDisplay === "none" ? "block" : "none";

  console.log("Toggle сработал. Статус:", categoryHover.style.display);
};

const hideFilter = (e) => {
  e.preventDefault();
  const categoryHover = document.querySelector("#category-filter-hover");
  if (categoryHover) categoryHover.style.display = "none";
};
const handleFilterEvents = () => {
  // const filtersBoolean = document.querySelector('.filter-section-boolean')
  // if (filtersBoolean) {
  // 	const help = filtersBoolean.querySelector('h4')
  // 	if (!help) {
  // 		const filtersBooleanHeading = document.createElement('h4')
  // 		filtersBooleanHeading.innerHTML = 'Štítky'
  // 		filtersBoolean.prepend(filtersBooleanHeading)
  // 	}
  // }
  // const filterSections = document.querySelectorAll('.filter-section')
  // if (filterSections.length) {
  // 	filterSections.forEach((section) => {
  // 		let heading = section.querySelector('h4')
  // 		if (heading) {
  // 			heading.addEventListener('click', (e) => {
  // 				e.preventDefault()
  // 				e.stopPropagation()
  // 				section.classList.toggle('filter-form-visible')
  // 				let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
  // 					parentClass = e.currentTarget.parentElement.className
  // 				parentClass = parentClass.replace('filter-form-visible', '')
  // 				parentClass = parentClass.trim()
  // 				if (cache.includes(parentClass)) {
  // 					cache = cache.filter((item) => {
  // 						return item !== parentClass
  // 					})
  // 				} else {
  // 					cache.push(parentClass)
  // 				}
  // 				window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
  // 			})
  // 		}
  // const filtersCount = section.querySelectorAll('.filter-label')
  // if (filtersCount.length > 7) {
  // 	section.classList.add('hide-more')
  // 	const showAllButton = document.createElement('button')
  // 	showAllButton.classList.add('show-all-filters')
  // 	showAllButton.innerText = 'Zobrazit všechny'
  // 	showAllButton.addEventListener('click', () => {
  // 		section.classList.toggle('hide-more')
  // 		if (section.classList.contains('hide-more')) {
  // 			showAllButton.innerText = 'Zobrazit všechny'
  // 		} else {
  // 			showAllButton.innerText = 'Skrýt'
  // 		}
  // 	})
  // 	section.appendChild(showAllButton)
  // }
  // 	})
  // }
  // const priceFilterCustom = document.querySelector('.slider-wrapper')
  // if (priceFilterCustom) {
  // 	priceFilterCustom.querySelector('h4').addEventListener('click', (e) => {
  // 		priceFilterCustom.classList.toggle('filter-form-visible')
  // 		let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
  // 			parentClass = e.currentTarget.parentElement.classList[0]
  // 		if (cache.includes(parentClass)) {
  // 			cache = cache.filter((item) => {
  // 				return item !== parentClass
  // 			})
  // 		} else {
  // 			cache.push(parentClass)
  // 		}
  // 		window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
  // 	})
  // }

  // let helperCache = window.sessionStorage.getItem('openedFilters')
  // if (helperCache) {
  // 	helperCache = JSON.parse(helperCache)
  // 	if (helperCache.length) {
  // 		helperCache.forEach((item) => {
  // 			item = item.replaceAll(' ', '.')
  // 			item = document.querySelector(`.${item}`)
  // 			if (item) item.classList.add('filter-form-visible')
  // 		})
  // 	}
  // }
  const booleanSection = document.querySelector(".filter-section-boolean");
  const categoryHover = document.querySelector("#category-filter-hover");
  let toggleButton = document.querySelector(".show-category-filter");

  if (booleanSection && categoryHover) {
    if (!toggleButton) {
      toggleButton = document.createElement("button");
      toggleButton.textContent = "Podrobný filtr";
      toggleButton.classList.add("btn", "show-category-filter");
      toggleButton.type = "button";
      booleanSection.append(toggleButton);
    }

    let closeButton = categoryHover.querySelector(".close-category-filter");
    if (!closeButton) {
      closeButton = document.createElement("button");
      closeButton.textContent = "Zavřít filtr";
      closeButton.classList.add("btn", "btn-default", "close-category-filter");
      closeButton.type = "button";
      categoryHover.appendChild(closeButton);
    }

    toggleButton.removeEventListener("click", toggleCategoryHover);
    toggleButton.addEventListener("click", toggleCategoryHover);

    closeButton.removeEventListener("click", hideFilter);
    closeButton.addEventListener("click", hideFilter);
  }

  const categoriesFilter = document.querySelector("#categories ul.active");
  if (categoriesFilter) {
    const liItems = categoriesFilter.querySelectorAll("li");
    const alreadyHasButton =
      categoriesFilter.parentElement.querySelector(".show-all-filters");
    if (liItems.length > 5 && !alreadyHasButton) {
      const showAllButton = document.createElement("button");
      showAllButton.classList.add("show-all-filters");
      showAllButton.innerText = "Zobrazit všechny";
      showAllButton.addEventListener("click", () => {
        categoriesFilter.classList.toggle("show-all");
        if (categoriesFilter.classList.contains("show-all")) {
          showAllButton.innerText = "Zobrazit všechny";
        } else {
          showAllButton.innerText = "Skrýt";
        }
      });
      categoriesFilter.parentElement.appendChild(showAllButton);
      categoriesFilter.classList.add("show-all");
    }
  }
};
if (
  dataLayer[0].shoptet.pageType === "category" ||
  document.body.classList.contains("type-manufacturer-detail")
) {
  handleFilterEvents();
  document.addEventListener("ShoptetDOMContentLoaded", handleFilterEvents);
}
if (dataLayer[0].shoptet.pageType === "category" && window.innerWidth < 768) {
  const appendFIltersWrapperToSubcategories = () => {
    const dklabFilters = document.querySelector(".dkLab-filters-wrapper");
    if (dklabFilters) {
      const subcategoriesFilterWrapper = document.querySelector(
        ".subcategories-filter-wrapper"
      );
      if (subcategoriesFilterWrapper) {
        subcategoriesFilterWrapper.appendChild(dklabFilters);
      }
    }
  };
  document.addEventListener(
    "dkLabFiltersLoaded",
    appendFIltersWrapperToSubcategories
  );
  document.addEventListener(
    "dkLabFiltersChanged",
    appendFIltersWrapperToSubcategories
  );
}
const backToTop = document.querySelector("#back-to-top");
if (backToTop) {
  backToTop.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  });
}

const handleFooter = async () => {
  // const socialIcons = document.querySelector('.footer-links-icons')
  // const contactBanner = document.querySelector('.custom-footer__contact')
  // if (socialIcons && contactBanner) contactBanner.appendChild(socialIcons)

  const signature = document.querySelector("#signature");
  if (signature) {
    const mirandaMediaLink = `
			<a class="company" href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
				<img class="company__logo" src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/eretail/assets/img/miranda_logo.png">
				MirandaMedia Group s.r.o
			</a>
		`;
    signature.insertAdjacentHTML("beforeend", mirandaMediaLink);
  }
  const footerHeadings = document.querySelectorAll(
    ".banner-wrapper > span > h4, .custom-footer__section2 > h3 "
  );

  footerHeadings.forEach((heading) => {
    heading.classList.add("clickable");
    heading.addEventListener("click", () => {
      heading.classList.toggle("active");
    });
  });
  // const footerCategories = document.querySelector(
  //   ".custom-footer__categories > h4"
  // );
  // if (footerCategories) {
  //   footerCategories.classList.add("clickable");
  //   footerCategories.addEventListener("click", () => {
  //     footerCategories
  //       .closest(".custom-footer__categories")
  //       .classList.toggle("active");
  //   });
  // }

  // const siteName = document.querySelector("#footer .site-name");
  // const siteNamePlaceholder = document.querySelector(
  //   "#footer .site-name-placeholder"
  // );
  // if (siteName && siteNamePlaceholder) {
  //   siteNamePlaceholder.append(siteName);
  // }
  const customFooterContact = document.querySelector(
    "#footer .custom-footer__contact"
  );
  const customFooterContactPlaceholder = document.querySelector(
    "#footer .contacts-placeholder"
  );
  if (customFooterContact && customFooterContactPlaceholder) {
    customFooterContactPlaceholder.append(customFooterContact);
  }

  // let prodejnyBanner = document.querySelector(".banner-prodejny");
  // if (prodejnyBanner) {
  //   prodejnyBanner = prodejnyBanner.closest(".banner").parentElement;
  //   if (dataLayer[0].shoptet.pageType === "homepage") {
  //     const siteFooter = document.querySelector("#footer");
  //     siteFooter.parentElement.insertBefore(prodejnyBanner, siteFooter);
  //   } else {
  //     prodejnyBanner.remove();
  //   }
  // }
};
handleFooter();

if (document.body.classList.contains("type-glossary")) {
  const glossaryListing = document.querySelector("#glossary-listing");
  const glossaryLinks = document.querySelectorAll("#glossary-listing a");
  const groupedGlossaryLinks = {};
  glossaryLinks.forEach((link) => {
    const firstLetter = link.textContent.charAt(0).toUpperCase();
    if (!groupedGlossaryLinks[firstLetter]) {
      groupedGlossaryLinks[firstLetter] = [];
    }
    groupedGlossaryLinks[firstLetter].push(link);
  });
  glossaryListing.innerHTML = "";
  for (const letter in groupedGlossaryLinks) {
    const groupWrapper = document.createElement("div");
    groupWrapper.classList.add("glossary-group");
    const groupHeading = document.createElement("h2");
    groupHeading.classList.add("glossary-title");
    groupHeading.innerText = letter;
    groupWrapper.appendChild(groupHeading);
    const linksWrapper = document.createElement("div");
    groupedGlossaryLinks[letter].forEach((link) => {
      linksWrapper.appendChild(link);
    });
    groupWrapper.appendChild(linksWrapper);
    glossaryListing.appendChild(groupWrapper);
  }
}

const categoryBanners = document.querySelector(
  '[class*="custom-footer__banner"]:has(.hp-banner)'
);
if (categoryBanners) {
  const footer = document.querySelector(".products-block");
  if (footer) footer.after(categoryBanners);
}
const prodejnaBanners = document.querySelector(
  '[class*="custom-footer__banner"]:has(.prodejna-banner)'
);
if (prodejnaBanners) {
  const footer = document.querySelector("#footer");
  if (footer) footer.before(prodejnaBanners);
}

const videoBanners = document.querySelector(
  '[class*="custom-footer__banner"]:has(.hp-video)'
);

if (videoBanners) {
  const footer = document.querySelector("#footer");
  if (footer) footer.before(videoBanners);

  if (window.innerWidth < 768) {
    const videoContainer = videoBanners.querySelector(".hp-video > div");

    const iframes = videoContainer.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      if (!iframe.parentElement.classList.contains("slide")) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("slide");
        iframe.parentElement.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
      }
    });

    $(videoContainer).slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      swipe: true,
      touchMove: true,
      draggable: true,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
    $(".slide").on("click", function () {
      const iframe = $(this).find("iframe")[0];
      $(this).siblings().find("iframe").css("pointer-events", "none");
      $(iframe).css("pointer-events", "auto");
    });
  }
}

const handleCustomFooter = (footer) => {
  const socialIcons = footer.querySelector(".footer-icons");
  const instagram = document.querySelector(".custom-footer__instagram");

  if (socialIcons && instagram) {
    const toRemove = socialIcons.closest(".footer-links-icons");
    if (toRemove) toRemove.remove();

    const instaWrapper = document.createElement("div");
    instaWrapper.classList.add("instagram-wrapper", "container");

    const instaHeader = document.createElement("div");
    instaHeader.classList.add("instagram-header");

    const instaHeading = document.createElement("div");
    instaHeading.classList.add("h3");
    instaHeading.innerText = "Sledujte naše sociální sítě";

    instaHeader.append(instaHeading, socialIcons);
    instaWrapper.append(instaHeader);

    const headingToRemove = instagram.querySelector("h4");
    if (headingToRemove) headingToRemove.remove();

    instaWrapper.appendChild(instagram);
    const pageFooter = document.querySelector("#footer");
    if (pageFooter) {
      pageFooter.before(instaWrapper);
    }
  }
};

const footer = document.querySelector("#footer");
if (footer) handleCustomFooter(footer);

const handleNewsletter = async () => {
  const newsletterEl = document.querySelector(".custom-footer__newsletter");
  if (newsletterEl) {
    const newsletterWrapper = document.createElement("div");
    newsletterWrapper.classList.add("newsletter-wrapper");
    const pageFooter = document.querySelector("#footer");
    newsletterWrapper.appendChild(newsletterEl);
    if (pageFooter)
      pageFooter.parentElement.insertBefore(newsletterWrapper, pageFooter);
    const newsletterHeadingEl = newsletterEl.querySelector(
      ".newsletter-header h3"
    );
    if (typeof newsletterNadpis !== "undefined" && newsletterHeadingEl)
      newsletterHeadingEl.innerHTML = newsletterNadpis;
    // nová struktura formulářů Shoptetu nemá placeholder, jen popisek
    const newsletterInput = newsletterEl.querySelector('input[type="email"]');
    if (newsletterInput && !newsletterInput.placeholder)
      newsletterInput.placeholder = "Váš e-mail";
    if (typeof newsletterBgDecor !== "undefined" && newsletterBgDecor)
      newsletterWrapper.style.setProperty(
        "--newsletter-bg-decor",
        `url(${newsletterBgDecor})`
      );
    if (typeof newsletterPerex !== "undefined" && newsletterPerex !== null) {
      const newsletterPerexEl = document.createElement("p");
      newsletterPerexEl.classList.add("newsletter-perex");
      newsletterPerexEl.innerHTML = newsletterPerex;
      newsletterEl.append(newsletterPerexEl);
    }
  }
};
handleNewsletter();

// --- Calculator helpers ---
// function getM2InPackage() {
//   let m2 = 0;

//   document.querySelectorAll(".extended-description tr").forEach((row) => {
//     const th = row.querySelector("th .row-header-label");
//     const tooltip = th?.querySelector(".show-tooltip");
//     const td = row.querySelector("td");
//     if (!td) return;

//     const labelText = th?.textContent.toLowerCase() || "";
//     const tooltipTitle =
//       tooltip?.getAttribute("data-original-title")?.toLowerCase() || "";

//     if (
//       labelText.includes("balení") ||
//       tooltipTitle.includes("množství produktu obsažené v jednom balení") ||
//       tooltipTitle.includes("množství")
//     ) {
//       let raw = td.textContent.trim();

//       raw = raw.replace(/m²|m2|m\^2/gi, "m²");
//       td.textContent = raw;
//       const match = raw.match(/(\d+(?:[.,]\d+)?)/);
//       if (match) {
//         m2 = Number(match[1].replace(",", "."));
//       } else {
//         const cleaned = raw
//           .replace(/m²|m2|m\^2/gi, "")
//           .replace(/[^0-9.,-]/g, "")
//           .trim();
//         if (cleaned) m2 = Number(cleaned.replace(",", "."));
//       }
//     }
//   });

//   return Number(m2 ? m2.toFixed(4) : 0);
// }
/**
 * Fetches the square meters per package from the API using the product code.
 * @param {string} productCode - The unique identifier for the product.
 * @returns {Promise<number>} - The packaging amount, rounded to 4 decimal places.
 */
async function getM2InPackage(productCode) {
  try {
    // Request product data from the external API
    const response = await fetch(
      `https://vpodlahy.mirandamedia.io/api/eshop/product-unit/code/${productCode}`
    );

    // If the response is not successful, log the status and return 0
    if (!response.ok) {
      console.warn(`API request failed with status: ${response.status}`);
      return 0;
    }

    const data = await response.json();

    // Extract the packaging amount (m2) from the JSON object.
    // Falls back to 0 if the field is missing.
    const m2 = data.packagingAmount || 0;

    // Return as a number with a fixed precision of 4 decimal places
    return Number(Number(m2).toFixed(4));
  } catch (error) {
    // Catch network errors or JSON parsing issues
    console.error("Error fetching packaging data:", error);
    return 0;
  }
}

function getPricePerPackage() {
  const priceElement = document.querySelector(
    ".price-final span.price-final-holder"
  );
  if (!priceElement) return 0;
  const priceText = priceElement.innerText
    .replace(/[^\d.,]/g, "")
    .replace(",", ".");
  return parseFloat(priceText) || 0;
}

function createDimensionRow(dimensionsContainer, updateCalculator) {
  const row = document.createElement("div");
  row.classList.add("dimension-row");

  // Width input
  const widthWrapper = document.createElement("div");
  widthWrapper.classList.add("input-with-icon");
  const widthIcon = document.createElement("img");
  widthIcon.src = "/user/documents/dist/assets/sirka.svg";
  widthIcon.alt = "šířka";
  widthIcon.classList.add("input-icon");
  const widthInput = document.createElement("input");
  widthInput.type = "number";
  widthInput.placeholder = "šířka";
  widthInput.classList.add("calculator-input");
  widthWrapper.append(widthIcon, widthInput);

  // Height input
  const heightWrapper = document.createElement("div");
  heightWrapper.classList.add("input-with-icon");
  const heightIcon = document.createElement("img");
  heightIcon.src = "/user/documents/dist/assets/vyska.svg";
  heightIcon.alt = "délka";
  heightIcon.classList.add("input-icon");
  const heightInput = document.createElement("input");
  heightInput.type = "number";
  heightInput.placeholder = "délka";
  heightInput.classList.add("calculator-input");
  heightWrapper.append(heightIcon, heightInput);

  // Result display
  const result = document.createElement("div");
  result.classList.add("calculator-result");
  result.innerText = "Plocha = 0 m²";

  // Remove button
  const removeButton = document.createElement("button");
  removeButton.type = "button";
  removeButton.classList.add("remove-dimension-button");
  removeButton.addEventListener("click", () => {
    row.remove();
    updateCalculator();
  });

  widthInput.addEventListener("input", updateCalculator);
  heightInput.addEventListener("input", updateCalculator);

  row.append(widthWrapper, heightWrapper, result, removeButton);
  dimensionsContainer.appendChild(row);
}

async function initCalculator() {
  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  if (!addToCartWrapper) return;

  // Calculator wrapper
  const calculatorWrapper = document.createElement("div");
  calculatorWrapper.classList.add("calculator-wrapper");

  // Toggle button
  const toggleButton = document.createElement("button");
  toggleButton.type = "button";
  toggleButton.classList.add("calculator-block-button");
  toggleButton.innerText = "Spočítat plochu";

  // Calculator block
  const calculatorBlock = document.createElement("div");
  calculatorBlock.classList.add("calculator-products-block");
  calculatorBlock.style.display = "none";

  // Title
  const title = document.createElement("h5");
  title.innerText = "Kalkulace plochy";
  title.classList.add("calculator-title");

  // Dimensions container
  const dimensionsContainer = document.createElement("div");
  dimensionsContainer.classList.add("dimensions-container");

  // Add dimension button
  const addDimensionButton = document.createElement("button");
  addDimensionButton.type = "button";
  addDimensionButton.classList.add("add-dimension-button");
  addDimensionButton.innerText = "Přidat rozměr";

  // Checkbox for extra
  const checkboxContainer = document.createElement("div");
  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.id = "extra-over";
  checkbox.name = "extra-over[]";
  checkbox.value = "5";
  checkbox.setAttribute("autocomplete", "off");

  const checkboxLabel = document.createElement("label");
  checkboxLabel.setAttribute("for", "extra-over");
  checkboxLabel.classList.add("filter-label");
  checkboxLabel.innerText = "potřebný nadměrek ";
  const checkboxCount = document.createElement("span");
  checkboxCount.classList.add("filter-count");
  checkboxCount.innerText = "5%";
  checkboxLabel.appendChild(checkboxCount);

  checkboxContainer.append(checkbox, checkboxLabel);

  // Results
  const extraResult = document.createElement("div");
  extraResult.classList.add("calculator-extra");
  extraResult.innerText = "Potřebný nadměrek (5 %) = 0 m²";
  extraResult.style.display = "none";

  const totalWithExtra = document.createElement("div");
  totalWithExtra.classList.add("calculator-total-extra");
  totalWithExtra.innerText = "Celkem s nadměrkem = 0 m²";
  totalWithExtra.style.display = "none";

  const packageResult = document.createElement("div");
  packageResult.classList.add("calculator-packages");
  packageResult.innerText = "Počet balení = 0 ks";

  const totalPriceDiv = document.createElement("div");
  totalPriceDiv.classList.add("calculator-total-price");
  totalPriceDiv.innerText = "0 Kč";

  // Buy button
  const buyButton = document.createElement("button");
  buyButton.type = "button";
  buyButton.classList.add(
    "calculator-buy-button",
    "btn",
    "btn-primary",
    "add-to-cart-button"
  );
  buyButton.innerText = "Koupit";

  const skuMeta = document.querySelector('meta[itemprop="sku"]');

  const productCode = skuMeta ? skuMeta.getAttribute("content") : "";

  console.log("Product code for calculator:", productCode);

  // Calculator state
  let m2InPackage = 0;
  let pricePerPackage = 0;

  try {
    const response = await fetch(
      `https://vpodlahy.mirandamedia.io/api/eshop/product-unit/code/${productCode}`
    );
    if (response.ok) {
      const data = await response.json();
      m2InPackage = data.packagingAmount || 0;
      pricePerPackage = data.packagingPrice || 0;
      if (data.includingVat === false) {
        pricePerPackage *= 1 + Number(data.vatRate || 0) / 100;
      }
    }
  } catch (error) {
    console.error("Failed to fetch product data for calculator:", error);
  }

  // Update calculator logic
  function updateCalculator() {
    let total = 0;
    dimensionsContainer.querySelectorAll(".dimension-row").forEach((row) => {
      const width = parseFloat(row.querySelectorAll("input")[0].value);
      const height = parseFloat(row.querySelectorAll("input")[1].value);
      const area = !isNaN(width) && !isNaN(height) ? width * height : 0;
      row.querySelector(
        ".calculator-result"
      ).innerText = `Plocha = ${area.toFixed(2)} m²`;
      total += area;
    });

    let finalTotal = total;
    if (checkbox.checked) {
      const extra = total * 0.05;
      extraResult.innerText = `Potřebný nadměrek (5 %) = ${extra.toFixed(
        2
      )} m²`;
      totalWithExtra.innerText = `Celkem s nadměrkem = ${(
        total + extra
      ).toFixed(2)} m²`;
      extraResult.style.display = "block";
      totalWithExtra.style.display = "block";
      finalTotal += extra;
    } else {
      extraResult.style.display = "none";
      totalWithExtra.style.display = "none";
    }

    if (m2InPackage > 0) {
      const packages = Math.ceil(finalTotal / m2InPackage);
      packageResult.innerText = `${packages} balení po ${m2InPackage.toFixed(
        4
      )} m²`;
      totalPriceDiv.innerText = `${(packages * pricePerPackage).toFixed(2)} Kč`;
    } else {
      packageResult.innerText = "Počet balení = (nelze určit)";
      totalPriceDiv.innerText = "0 Kč";
    }
  }

  // Buy button handler
  function handleBuy() {
    const cartAmountInput = document.querySelector(".quantity input.amount");
    const addToCartButton = document.querySelector(".add-to-cart-button");
    const match = packageResult.innerText.match(/(\d+)\s+balení/);
    const packagesCount = match ? parseInt(match[1]) : 0;
    if (packagesCount > 0) {
      cartAmountInput.value = packagesCount;
      cartAmountInput.dispatchEvent(new Event("input", { bubbles: true }));
      addToCartButton.click();

      // --- Reset calculator after adding to cart ---
      // Remove all dimension rows except one
      const rows = dimensionsContainer.querySelectorAll(".dimension-row");
      rows.forEach((row, idx) => {
        if (idx > 0) row.remove();
      });
      // Clear inputs in the remaining row
      const firstRowInputs = dimensionsContainer.querySelectorAll(
        ".dimension-row input"
      );
      firstRowInputs.forEach((input) => (input.value = ""));
      // Uncheck extra checkbox
      checkbox.checked = false;
      // Update calculator display
      updateCalculator();
    } else {
      alert("Nelze určit počet balení pro nákup.");
    }
  }

  buyButton.addEventListener("click", handleBuy);
  addDimensionButton.addEventListener("click", () =>
    createDimensionRow(dimensionsContainer, updateCalculator)
  );
  checkbox.addEventListener("change", updateCalculator);

  // Initial dimension row
  createDimensionRow(dimensionsContainer, updateCalculator);

  // Build calculator block
  calculatorBlock.append(
    title,
    dimensionsContainer,
    addDimensionButton,
    checkboxContainer,
    extraResult,
    totalWithExtra,
    totalPriceDiv,
    packageResult,
    buyButton
  );

  calculatorWrapper.append(toggleButton, calculatorBlock);
  addToCartWrapper.after(calculatorWrapper);

  toggleButton.addEventListener("click", () => {
    calculatorBlock.style.display =
      calculatorBlock.style.display === "none" ? "flex" : "none";
  });

  updateCalculator();
}

initCalculator();

const handledmproducts = () => {
  const dmproducts = document.querySelector(".dmproducts");
  if (!dmproducts) return;

  const contentWrapperIn = document.querySelector(".content-wrapper-in");
  if (contentWrapperIn) contentWrapperIn.after(dmproducts);

  if (!dmproducts.querySelector("h2")) {
    const heading = document.createElement("h2");
    heading.classList.add("dmproducts-heading", "h2");
    heading.innerText = "Produkty v tomto článku";
    dmproducts.before(heading);
  }

  const processedSet = new WeakSet();

  const processProducts = () => {
    const products = dmproducts.querySelectorAll(".product");
    let anyProcessed = false;

    products.forEach((product) => {
      // moveAddToFavorites(product);

      if (!processedSet.has(product)) {
        handleProductAddToCartButton(product);
        processedSet.add(product);
        anyProcessed = true;
      }
    });

    if (
      products.length &&
      !dmproducts.classList.contains("slick-initialized")
    ) {
      $(dmproducts).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
          { breakpoint: 480, settings: { slidesToShow: 1.2, arrows: false } },
        ],
      });
    }

    return anyProcessed;
  };

  processProducts();

  const observer = new MutationObserver(() => processProducts());
  observer.observe(dmproducts, { childList: true, subtree: true });
};

if (document.body.classList.contains("type-post")) {
  window.waitFor(".dmproducts").then(() => {
    handledmproducts();
  });
}

const handleRecentlyViewedProducts = () => {
  const dvpnProducts = document.querySelector(".dvpnProducts");
  if (dvpnProducts) {
    if (!$(dvpnProducts).hasClass("slick-initialized")) {
      $(dvpnProducts).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1.3,
            },
          },
        ],
      });
    }
  }
};
window.waitFor(".dkLabVisitedProductsNew").then(() => {
  handleRecentlyViewedProducts();
});

const observer = new MutationObserver(() => {
  document
    .querySelectorAll(
      "#personal-collection-wrapper [data-testid='buttonWarehouseDeliveryPoint'].disabled"
    )
    .forEach((btn) => {
      btn.classList.replace("disabled", "enabled");
    });
});
observer.observe(document.body, { childList: true, subtree: true });
